<template>
  <div class="d-flex justify-content-between my-4">
    <div class="title d-none d-md-block" v-if="false">
      <div>{{ $t('slogan-line-1') }}</div>
      <div>{{ $t('slogan-line-2') }}</div>
    </div>

    <!-- Mobile navigation (hamburger only) -->
    <div class="d-flex d-md-none justify-content-between align-items-center w-100">
      <!-- Empty div for spacing -->
      <div></div>

      <!-- Logo in the center -->
      <div class="logo">
        <router-link :to="{name: 'home'}"><img src="/static/logo.png"/></router-link>
      </div>

      <!-- Hamburger menu icon on the right -->
      <div class="hamburger-icon" @click="toggleMobileMenu">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12H21" stroke="#6B6B9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 6H21" stroke="#6B6B9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 18H21" stroke="#6B6B9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <!-- Desktop logo and navigation -->
    <div class="d-none d-md-flex align-items-center">
      <div class="logo">
        <router-link :to="{name: 'home'}"><img src="/static/logo.png"/></router-link>
      </div>
    </div>

    <!-- Desktop menu -->
    <div class="d-none d-md-flex align-items-center desktop-menu">
      <div class="menu-link">
        <router-link :to="{name: 'about'}">
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.6148 1.63526C12.293 0.42998 10.4424 0.298152 8.98838 0.900792C8.87508 0.938457 8.72401 1.03262 8.57294 1.12678C8.55406 1.12678 8.55406 1.12678 8.53517 1.14561C8.36522 1.23978 8.17639 1.39044 7.77983 1.39044C7.51546 1.39044 7.28886 1.25861 7.17556 1.20211C7.15668 1.18328 7.13779 1.16445 7.11891 1.16445C6.91119 1.03262 6.66571 0.900792 6.3258 0.787797C4.75847 0.241655 3.04007 0.618305 1.69934 2.31323C0.434145 3.83866 0.283076 5.83491 1.3972 7.83116C2.68128 10.1287 6.17473 9.46958 7.30774 8.71628C7.83648 8.3773 8.17639 8.11364 8.38411 7.79349C8.79954 7.13435 8.51629 6.39988 8.36522 6.17389C8.25192 6.0044 8.11974 5.85374 7.94978 5.74075C7.34551 5.3076 6.79789 5.42059 6.23138 5.66542C5.89148 5.81608 5.55158 6.0044 5.19279 6.13623C4.32415 6.45638 3.39886 5.96674 3.17225 5.08161C2.7757 3.63151 3.75764 2.21907 5.28721 1.88008C6.08032 1.71059 6.72236 2.04958 7.15668 2.42623C7.51546 2.74638 8.08197 2.70871 8.40299 2.3509C8.59182 2.14374 8.79954 1.97425 8.98838 1.88008C10.1214 1.37161 11.1222 1.5976 11.8776 2.48272C12.5951 3.31135 12.784 4.29064 12.5385 5.15694C12.3119 5.9479 11.8964 6.8142 10.9334 7.41684C10.348 7.77466 9.80037 7.71816 9.13945 8.05715C8.47852 8.39613 7.98755 8.82928 7.89313 9.67674C7.77983 10.7879 8.55406 11.1645 9.21498 11.2398C10.2347 11.3528 12.1797 11.0703 13.9547 8.69745C15.9186 6.0609 15.371 3.23602 13.6148 1.63526Z"
                fill="#6B6B9C"/>
          </svg>
          <span>
            {{ $t('navigation-bar-about-link') }}
          </span>
        </router-link>
      </div>
      <div class="menu-link">
        <router-link :to="{name: 'survey'}">
          <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_1385_965" fill="white">
              <rect x="0.580566" y="0.219727" width="5.573" height="5.573" rx="1"/>
            </mask>
            <rect x="0.580566" y="0.219727" width="5.573" height="5.573" rx="1" stroke="#6B6B9C" stroke-width="2.8" mask="url(#path-1-inside-1_1385_965)"/>
            <mask id="path-2-inside-2_1385_965" fill="white">
              <rect x="0.580566" y="7.33887" width="5.573" height="5.573" rx="1"/>
            </mask>
            <rect x="0.580566" y="7.33887" width="5.573" height="5.573" rx="1" stroke="#6B6B9C" stroke-width="2.8" mask="url(#path-2-inside-2_1385_965)"/>
            <path d="M8.68701 3.00635L17.1809 3.00635" stroke="#6B6B9C" stroke-width="2" stroke-linecap="round"/>
            <path d="M8.68701 10.1255L17.1809 10.1255" stroke="#6B6B9C" stroke-width="2" stroke-linecap="round"/>
          </svg>

          <span>
            {{ $t('navigation-bar-survey-link') }}
          </span>
        </router-link>
      </div>
      <div class="menu-link">
        <router-link :to="{ name: 'partnership' }">
          <span>{{ locale === 'bg' ? 'За компаниите' : 'About companies' }}</span>
        </router-link>
      </div>
      <MainButton @click="$router.push({name: 'subscribe'})" v-if="false">{{ $t('home-signup-button') }}</MainButton>
      <div class="lang-btn d-none d-md-block" v-if="locale === 'bg'" @click="setLanguage('en')">EN</div>
      <div class="lang-btn d-none d-md-block" v-if="locale === 'en'" @click="setLanguage('bg')">БГ</div>
      <MainButton class="download-btn" @click="goToDownload">
        {{ locale === 'bg' ? 'Свали приложението' : 'Download the app' }}
      </MainButton>
    </div>

    <!-- Mobile menu -->
    <div class="mobile-menu" :class="{ 'active': mobileMenuOpen }">
      <div class="mobile-menu-content">
        <!-- Language button at the top left -->
        <div class="mobile-lang-btn mb-3">
          <div class="lang-btn d-flex" v-if="locale === 'bg'" @click="setLanguage('en'); toggleMobileMenu()">EN</div>
          <div class="lang-btn d-flex" v-if="locale === 'en'" @click="setLanguage('bg'); toggleMobileMenu()">БГ</div>
        </div>
        <div class="menu-link">
          <router-link :to="{name: 'about'}" @click="toggleMobileMenu">
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M13.6148 1.63526C12.293 0.42998 10.4424 0.298152 8.98838 0.900792C8.87508 0.938457 8.72401 1.03262 8.57294 1.12678C8.55406 1.12678 8.55406 1.12678 8.53517 1.14561C8.36522 1.23978 8.17639 1.39044 7.77983 1.39044C7.51546 1.39044 7.28886 1.25861 7.17556 1.20211C7.15668 1.18328 7.13779 1.16445 7.11891 1.16445C6.91119 1.03262 6.66571 0.900792 6.3258 0.787797C4.75847 0.241655 3.04007 0.618305 1.69934 2.31323C0.434145 3.83866 0.283076 5.83491 1.3972 7.83116C2.68128 10.1287 6.17473 9.46958 7.30774 8.71628C7.83648 8.3773 8.17639 8.11364 8.38411 7.79349C8.79954 7.13435 8.51629 6.39988 8.36522 6.17389C8.25192 6.0044 8.11974 5.85374 7.94978 5.74075C7.34551 5.3076 6.79789 5.42059 6.23138 5.66542C5.89148 5.81608 5.55158 6.0044 5.19279 6.13623C4.32415 6.45638 3.39886 5.96674 3.17225 5.08161C2.7757 3.63151 3.75764 2.21907 5.28721 1.88008C6.08032 1.71059 6.72236 2.04958 7.15668 2.42623C7.51546 2.74638 8.08197 2.70871 8.40299 2.3509C8.59182 2.14374 8.79954 1.97425 8.98838 1.88008C10.1214 1.37161 11.1222 1.5976 11.8776 2.48272C12.5951 3.31135 12.784 4.29064 12.5385 5.15694C12.3119 5.9479 11.8964 6.8142 10.9334 7.41684C10.348 7.77466 9.80037 7.71816 9.13945 8.05715C8.47852 8.39613 7.98755 8.82928 7.89313 9.67674C7.77983 10.7879 8.55406 11.1645 9.21498 11.2398C10.2347 11.3528 12.1797 11.0703 13.9547 8.69745C15.9186 6.0609 15.371 3.23602 13.6148 1.63526Z"
                  fill="#6B6B9C"/>
            </svg>
            <span>
              {{ $t('navigation-bar-about-link') }}
            </span>
          </router-link>
        </div>
        <div class="menu-link">
          <router-link :to="{name: 'survey'}" @click="toggleMobileMenu">
            <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_1385_965" fill="white">
                <rect x="0.580566" y="0.219727" width="5.573" height="5.573" rx="1"/>
              </mask>
              <rect x="0.580566" y="0.219727" width="5.573" height="5.573" rx="1" stroke="#6B6B9C" stroke-width="2.8" mask="url(#path-1-inside-1_1385_965)"/>
              <mask id="path-2-inside-2_1385_965" fill="white">
                <rect x="0.580566" y="7.33887" width="5.573" height="5.573" rx="1"/>
              </mask>
              <rect x="0.580566" y="7.33887" width="5.573" height="5.573" rx="1" stroke="#6B6B9C" stroke-width="2.8" mask="url(#path-2-inside-2_1385_965)"/>
              <path d="M8.68701 3.00635L17.1809 3.00635" stroke="#6B6B9C" stroke-width="2" stroke-linecap="round"/>
              <path d="M8.68701 10.1255L17.1809 10.1255" stroke="#6B6B9C" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span>
              {{ $t('navigation-bar-survey-link') }}
            </span>
          </router-link>
        </div>
        <div class="menu-link">
          <router-link :to="{ name: 'partnership' }" @click="toggleMobileMenu">
            <span>{{ locale === 'bg' ? 'За компаниите' : 'About companies' }}</span>
          </router-link>
        </div>
        <div class="mt-3 w-100">
          <MainButton class="download-btn w-100 text-center" @click="goToDownload(); toggleMobileMenu()">
            {{ locale === 'bg' ? 'Свали приложението' : 'Download the app' }}
          </MainButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import MainButton from '@/components/Common/Buttons/MainButton.vue';
import {useI18n} from "vue-i18n";
import {setLang} from "@/i18n";
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const {locale} = useI18n();
const mobileMenuOpen = ref(false);
const router = useRouter();

function setLanguage(lang) {
  setLang(lang);
}

function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value;
}

function goToDownload() {
  const targetRoute = locale.value === 'en' ? 'download-en' : 'download';
  router.push({ name: targetRoute });
}
</script>

<style lang="scss" scoped>
.menu-link {
  display: block;
  font-size: 15px;
  padding: 0;
  color: $color-purple;
  span {
    display: inline-block;
    padding: 0 0 0 2px;
  }
}

.mobile-lang-btn {
  position: absolute;
  top: 20px;
  left: 10px;
}

.lang-btn {
  padding: 12px 16px;
  border: 2px solid $color-pink-dark-2;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 0;
  cursor: pointer;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  color: $color-pink-dark-2;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(255, 192, 203, 0.2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(255, 192, 203, 0.4);
    border-color: $color-pink-dark;
    background: linear-gradient(135deg, $color-pink-dark-2 0%, $color-pink-dark 100%);
    color: white;

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(255, 192, 203, 0.3);
  }

  // Add a subtle pulse animation
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 2px 8px rgba(255, 192, 203, 0.2);
  }
  50% {
    box-shadow: 0 2px 12px rgba(255, 192, 203, 0.3);
  }
  100% {
    box-shadow: 0 2px 8px rgba(255, 192, 203, 0.2);
  }
}

.logo {
  width: 160px;

  img {
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 140px;
    margin-top: 10px;
  }
}

.title {
  font-size: 12px;
  color: $color-purple;
}

.hamburger-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 1001;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 100%;
  height: 100vh;
  background-color: white;
  z-index: 1000;
  transition: right 0.3s ease;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 80px 20px 20px;

  &.active {
    right: 0;
  }

  .menu-link {
    border-bottom: 1px solid $color-pink-light;
    width: 100%;
  }
}

.mobile-menu-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  /* Equal spacing between mobile nav items */
  .menu-link {
    margin-bottom: 14px;
  }

  .menu-link:last-of-type {
    margin-bottom: 0;
  }
}

.btn-link {
  background: $color-pink-dark;
  color: #fff;
  border-radius: 20px;
  padding: 10px 15px;
  font-size: 13px;
  text-decoration: none;
  display: inline-block;

  &:hover {
    color: $color-pink-dark;
    outline: 2px solid $color-pink-dark;
  }
}

.desktop-menu {
  gap: 16px;
}

/* Desktop: nudge the first nav link ("За нас") slightly left */
@media (min-width: 768px) {
  .desktop-menu > .menu-link:first-child {
    margin-left: 0;
    transform: translateX(-8px);
  }
}

.download-btn {
  background: #fc678b;
  border: none;
  color: #fff;
  padding: 12px 28px;
  border-radius: 28px;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.2px;
  box-shadow: 0 4px 10px rgba(252, 103, 139, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin-left: 0 !important;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(252, 103, 139, 0.4);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 3px 8px rgba(252, 103, 139, 0.3);
  }
}
</style>
